/** 소식 화면의 탭. Ghost 태그(`notice`·`story`)가 정본이라 라벨도 그 둘만 둔다. */
export interface BoardTab {
  tag: string
  label: string
}

export const PAGE_SIZE = 15

const NOTICE: BoardTab = { tag: 'notice', label: '소식' }

export const BOARD_TABS: BoardTab[] = [NOTICE, { tag: 'story', label: '이야기' }]

/** 주소로 들어온 태그를 탭으로 읽는다. 모르는 값이면 소식이다. */
export function boardTabOf(tag: string | null): BoardTab {
  return BOARD_TABS.find((t) => t.tag === tag) ?? NOTICE
}
